import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faThumbtack } from "@fortawesome/pro-duotone-svg-icons";
import ReactHtmlParser from "react-html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import type ArticleFootnote from "@/src/_types/Article/article-footnote";

const ArticleFootnotes = (
    {
        footnotes
    }: {
        footnotes: ArticleFootnote[]
    }
) => (
    <Box
        component="section"
        role="doc-footnotes"
        mt={1}
    >
        <Typography
            component="h3"
            color="primary"
            mb={2}
        >
            <SpanTypography
                color="primary.main"
                mr={.5}
            >
                <FontAwesomeIcon
                    icon={faThumbtack}
                />
            </SpanTypography>
            <SpanTypography
                fontSize={'1.5rem'}
            >
                Footnotes
            </SpanTypography>
        </Typography>
        <Box component="aside">
            <List sx={{ py: 0 }}>
                {
                    footnotes.map((
                        footnote: ArticleFootnote,
                        index: number
                    ) => (
                        <ListItem
                            key={`footnote-${index}`}
                            sx={{ py: 0 }}
                        >
                            <ListItemText sx={{ my: 0 }}>
                                <Typography
                                    display={{
                                        xs: 'flex',
                                        sm: 'flex',
                                        md: 'block'
                                    }}
                                    alignItems={{
                                        xs: 'flex-start',
                                        sm: 'flex-start',
                                        md: 'center'
                                    }}
                                    flexDirection={{
                                        xs: 'column',
                                        sm: 'column',
                                        md: 'row'
                                    }}
                                >
                                    <SpanTypography
                                        display={{
                                            xs: 'flex',
                                            sm: 'flex',
                                            md: 'inline'
                                        }}
                                        alignItems="center"
                                    >
                                        <SpanTypography
                                            display="inline"
                                        >
                                            <SpanTypography
                                                position="relative"
                                                top={-3}
                                                fontSize={6}
                                                mr={.25}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faCircle}
                                                />
                                            </SpanTypography>
                                            <SpanTypography
                                                fontWeight="bold"
                                                mr={.25}
                                            >
                                                {
                                                    footnote.label
                                                }
                                            </SpanTypography>
                                        </SpanTypography>
                                    </SpanTypography>
                                    <SpanTypography
                                        display="inline"
                                        variant="body1"
                                        fontSize={'1rem'}
                                    >
                                        {
                                            ReactHtmlParser(footnote.content)
                                        }
                                    </SpanTypography>
                                </Typography>
                            </ListItemText>
                        </ListItem>
                    ))
                }
            </List>
        </Box>
    </Box>
)

export default ArticleFootnotes;